import { render, staticRenderFns } from "./yc-profit-page.vue?vue&type=template&id=7fbf7489&scoped=true&"
import script from "./yc-profit-page.vue?vue&type=script&lang=js&"
export * from "./yc-profit-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbf7489",
  null
  
)

export default component.exports